import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import SuperAdminPortal from "@/pages/SuperAdminPortal";
import InfluencerDashboard from "@/pages/InfluencerDashboard";
import ClientApp from "@/pages/ClientApp";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  return (
    <div className="min-h-screen bg-vexl-bg">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<SuperAdminPortal />} />
          <Route path="/influencer/:accessCode" element={<InfluencerDashboard />} />
          <Route path="/:brandName" element={<ClientApp />} />
          <Route path="/:brandName/payment-success" element={<PaymentSuccess />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;
